/**
 * PROTOTYPE CONTENT — NOT VERIFIED.
 *
 * Restored verbatim from `design-reference/`. **None of these people are real.**
 * The names, titles, professional registrations and biographies were invented to
 * demonstrate the layout, and none of them appear on the CIPC director list. The
 * only confirmed person behind Samloryx Engineering is Samuel Komane, who
 * registered the company on 8 August 2026.
 *
 * Replace this list with the actual directors before publication, and let each
 * person approve their own entry. See CONTENT-STATUS.md.
 */
export interface Leader {
  name: string
  role: string
  /** Professional registrations and qualifications. */
  cred: string
  bio: string
}

export const leaders: Leader[] = [
  {
    name: 'Samuel Lorimer Xaba',
    role: 'Founder & Managing Director',
    cred: 'PrEng, MSc (Civil), Wits',
    bio: 'Nineteen years on national roads and mine civils, most recently as a contracts manager on a R700 m provincial upgrade, before registering Samloryx in February 2026.',
  },
  {
    name: 'Nolwazi Mahlangu',
    role: 'Director: Operations',
    cred: 'PrCM, BTech (Civil)',
    bio: 'Fourteen years running Gauteng earthworks and bulk services contracts. Holds the principal-contractor appointments and runs the yard in Burgersfort.',
  },
  {
    name: 'Thandiwe Sithole',
    role: 'Financial Director',
    cred: 'CA(SA)',
    bio: 'Built the finance function from the registration certificate up, including the CIDB financial-capability submission and the group risk register.',
  },
  {
    name: 'Kagiso Mmusi',
    role: 'SHEQ Manager',
    cred: 'SAMTRAC, NEBOSH IGC',
    bio: 'Owns the zero-harm programme and the road to ISO 45001 certification, targeted for the second quarter of 2027.',
  },
]
